export default "__VITE_ASSET__a8e8fe31__"